import moment from 'moment';
import Papa from 'papaparse';
import _ from 'underscore';

angular.module('am4').controller('reportCtrl', function($scope, $state, $interval, workoutDataService, appCacheService, $stateParams, filterService, $rootScope, downloadService, errorService, viewableMachines, $translate, syncReport, Analytics, usageReport) {
    var that = this,
        nonActiveReportTypes = [
            {
                name: 'TOTAL_HOURLY_USAGE_PERCENT_BY_EQUIPMENT_TYPE',
                subtypeMenu: false,
                simpleTimeMenu: true,
                fullMenu: false,
                restrictedCols: ['series', 'status'],
                interval: 'daily',
                groups: ['machine_type_code'],
                groupBy: 'QUICK_REPORTS'
            },
            {
                name: 'TOTAL_HOURLY_USAGE_PERCENT_BY_MODEL',
                subtypeMenu: false,
                simpleTimeMenu: true,
                fullMenu: false,
                restrictedCols: ['status'],
                interval: 'daily',
                groups: ['series'],
                groupBy: 'QUICK_REPORTS'
            },
            {
                name: 'HEALTHY_AND_UNHEALTHY_EQUIPMENT',
                subtypeMenu: true,
                simpleTimeMenu: false,
                fullMenu: false,
                restrictedCols: ['machine_type_code', 'series', 'status'],
                groupBy: 'QUICK_REPORTS'
            },
            {
                name: 'ERROR_ALERT_OFFLINE_EQUIPMENT',
                subtypeMenu: true,
                simpleTimeMenu: false,
                fullMenu: false,
                restrictedCols: ['machine_type_code', 'series', 'status'],
                groupBy: 'QUICK_REPORTS'
            },
            {
                name: 'AVERAGE_USAGE_PERCENT',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: true,
                groupBy: 'CUSTOM_REPORTS'
            },
            {
                name: 'ACCUMULATED_TIME_DISTANCE_ERRORS',
                subtypeMenu: false,
                simpleTimeMenu: false,
                simpleTimeMenu2: true,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST'
            },
            {
                name: 'EQUIPMENT_LIST',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'QUICK_REPORTS'
            },
            {
                name: 'EQUIPMENT_WITH_AN_ERROR',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST',
                type: 'RESULTS_LIST',
                meta: {
                    selectedStatus: ['HAS_ERROR_CODE']
                }
            },
            {
                name: 'EQUIPMENT_WITH_A_SERVICE_CODE',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST',
                type: 'RESULTS_LIST',
                meta: {
                    selectedStatus: ['HAS_SERVICE_CODE']
                }
            },
            {
                name: 'EQUIPMENT_OFFLINE',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST',
                type: 'RESULTS_LIST',
                meta: {
                    selectedStatus: ['NOT_ONLINE']
                }
            },
            {
                name: 'EQUIPMENT_HEALTHY',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST',
                type: 'RESULTS_LIST',
                meta: {
                    selectedStatus: ['HEALTHY']
                }
            },
            {
                name: 'EQUIPMENT_UNHEALTHY',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST',
                type: 'RESULTS_LIST',
                meta: {
                    selectedStatus: ['UNHEALTHY']
                }
            }
        ],
        activeReportTypes = [
            {
                name: 'EQUIPMENT_ACTIVE',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST',
                type: 'RESULTS_LIST',
                meta: {
                    selectedStatus: ['ACTIVE']
                }
            },
            {
                name: 'EQUIPMENT_INACTIVE',
                subtypeMenu: false,
                simpleTimeMenu: false,
                fullMenu: false,
                groupBy: 'EQUIPMENT_LIST',
                type: 'RESULTS_LIST',
                meta: {
                    selectedStatus: ['INACTIVE']
                }
            },
            {
                name: 'ACTIVE_AND_INACTIVE_EQUIPMENT',
                subtypeMenu: true,
                simpleTimeMenu: false,
                fullMenu: false,
                restrictedCols: ['machine_type_code', 'series', 'status'],
                groupBy: 'QUICK_REPORTS'
            }
        ];

    that.simpleTimeOptions = [
        {
            name: 'LAST_24_HOURS',
            start: moment().subtract(1, 'days').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_WEEK',
            start: moment().subtract(7, 'days').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_2_WEEKS',
            start: moment().subtract(2, 'weeks').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_MONTH',
            start: moment().subtract(1, 'months').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_3_MONTHS',
            start: moment().subtract(3, 'months').toDate(),
            end: moment().toDate()
        }
    ];

    that.simpleTimeOptions2 = [
        {
            name: 'LAST_24_HOURS',
            start: moment().subtract(1, 'days').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_WEEK',
            start: moment().subtract(7, 'days').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_2_WEEKS',
            start: moment().subtract(2, 'weeks').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_MONTH',
            start: moment().subtract(1, 'months').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_3_MONTHS',
            start: moment().subtract(3, 'months').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_6_MONTHS',
            start: moment().subtract(6, 'months').toDate(),
            end: moment().toDate()
        },
        {
            name: 'LAST_YEAR',
            start: moment().subtract(1, 'year').toDate(),
            end: moment().toDate()
        },
        {
            name: 'CURRENT_CALENDAR_YEAR',
            start: moment().dayOfYear(1).hour(0).minute(0).second(0).millisecond(0).toDate(),
            end: moment().toDate()
        },
        {
            name: 'SPECIFIC_MONTH'
        }
    ];

    that.monthOptions = _.range(24).map(i => {
        return {
            start: moment().subtract(i, 'months').startOf('month').toDate(),
            end: i === 0 ? moment().toDate() : moment().subtract(i, 'months').endOf('month').toDate(),
            display: moment().subtract(i, 'months').locale($translate.use()).format('MMMM YYYY')
        };
    });

    that.selectedReport = '';
    that.simpleTimeFrame = '';
    that.simpleTimeFrame2 = '';
    that.monthSelection = undefined;
    that.invalidColumns = [];

    that.state = appCacheService.getAppCache('appState');

    that.getFilterPredicate = function() {
        if (that.state.activeMachinesOnly && that.state.deleted) {
            return m => m.is_active;
        }
        if (that.state.activeMachinesOnly && !that.state.deleted) {
            return m => m.is_active && !m.is_removed;
        }
        if (!that.state.activeMachinesOnly && !that.state.deleted) {
            return m => !m.is_removed;
        }
        return () => true;
    };

    function createQueryGroups(groups) {
        let groupAry = [],
            groupingObj = {},
            groupingString,
            groupObj,
            split;

        _.filter(viewableMachines(), that.getFilterPredicate()).forEach(mach => {
            groupingString = groups.map(grouper => mach[grouper]).join('#');
            if (!groupingObj[groupingString]) {
                groupingObj[groupingString] = [{
                    frame_serial_number: mach.frame_serial,
                    facility_id: mach.facility_id
                }];
            } else {
                groupingObj[groupingString].push({
                    frame_serial_number: mach.frame_serial,
                    facility_id: mach.facility_id
                });
            }
        });

        _(groupingObj).keys().forEach(key => {
            split = key.split('#');
            groupObj = {
                group: {},
                machines: groupingObj[key]
            };

            split.forEach((item, idx) => {
                groupObj.group[groups[idx]] = item;
            });

            groupAry.push(groupObj);
        });

        return groupAry;
    }

    that.reportTypes = that.state.activeMachinesOnly ? nonActiveReportTypes : nonActiveReportTypes.concat(activeReportTypes);

    that.yesterday = moment().subtract(1, 'day').toDate();

    that.query = {
        start: null,
        end: null,
        filters: {}
    };

    $scope.$watch(function() {
        return appCacheService.getAppCache('appState').activeMachinesOnly;
    }, function() {
        that.state = appCacheService.getAppCache('appState');
        that.reportTypes = that.state.activeMachinesOnly ? nonActiveReportTypes : nonActiveReportTypes.concat(activeReportTypes);
    });

    $scope.$watch(function() {
        return _.filter(viewableMachines(), that.getFilterPredicate()).length;
    }, function(l) {
        that.filteringOnMachines = l;
    });

    $scope.$watch(function() {
        return that.group;
    }, function() {
        if (that.group) {
            that.state.report.groups.push(that.group);
            that.state.report.groupOptions.splice(that.state.report.groupOptions.indexOf(that.group), 1);
            that.group = null;
        }
    });

    that.removeGroupOption = function(g) {
        that.state.report.groupOptions.push(g);
        that.state.report.groups.splice(that.state.report.groups.indexOf(g), 1);
    };

    that.submit = function() {

        var workoutReports = [
            'TOTAL_HOURLY_USAGE_PERCENT_BY_EQUIPMENT_TYPE',
            'TOTAL_HOURLY_USAGE_PERCENT_BY_MODEL',
            'AVERAGE_USAGE_PERCENT'
        ];

        Analytics.trackEvent('report', 'submit', that.selectedReport.name);

        if (that.selectedReport.type === 'RESULTS_LIST') {
            // https://i.imgur.com/l7bslIv.jpg

            let i;

            for (i = 0; i < that.selectedReport.meta.selectedStatus.length; i++) {
                let status = that.selectedReport.meta.selectedStatus[i];

                if ($scope.dash.availableOptions.status.indexOf(status) !== -1) {
                    // Found at least one matching status requirement
                    break;
                }

                // There are no equipmentses with error; fail now
                if (i === that.selectedReport.meta.selectedStatus.length - 1) {
                    // We're at the end of the loop with no matches
                    return showReport(that.selectedReport, false);
                }
            }

            // Disable all status options that are NOT that.selectedReport.meta.status
            const statusOpts = $scope.dash.availableOptions.status;
            for (i = 0; i < statusOpts.length; i++) {
                let key = statusOpts[i];

                if (that.selectedReport.meta.selectedStatus.indexOf(key) !== -1) {
                    // If not checked already, check it
                    if (!$scope.dash.checked.status[key]) {
                        $scope.dash.toggleOptions(key, 'status');
                    }
                } else if ($scope.dash.checked.status[key]) {
                    // If checked already, uncheck it
                    $scope.dash.toggleOptions(key, 'status');
                }
            }

            return showReport(that.selectedReport, true);
        }

        let reportData;

        if (that.selectedReport.name === 'ACTIVE_AND_INACTIVE_EQUIPMENT') {

            reportData = syncReport.activeInactiveEquipment($scope.dash.availableOptions.facility_id);

            return showReport(that.selectedReport, reportData);

        } else if (that.selectedReport.name === 'HEALTHY_AND_UNHEALTHY_EQUIPMENT') {

            reportData = syncReport.healthyUnhealthyEquipment($scope.dash.availableOptions.facility_id);

            return showReport(that.selectedReport, reportData);

        } else if (that.selectedReport.name === 'EQUIPMENT_LIST') {

            return $scope.dash.exportMachines();

        } else if (that.selectedReport.name === 'ERROR_ALERT_OFFLINE_EQUIPMENT') {

            reportData = syncReport.errorAlertOfflineEquipment($scope.dash.availableOptions.facility_id);

            return showReport(that.selectedReport, reportData);
        } else if (_(workoutReports).contains(that.selectedReport.name)) {
            that.loading = true;

            let myQuery = angular.copy(that.query);

            if (that.selectedReport.simpleTimeMenu) {
                myQuery.groups = that.selectedReport.groups;
                myQuery.interval = that.selectedReport.interval;
                myQuery.start = that.simpleTimeFrame.start;
                myQuery.end = that.simpleTimeFrame.end;

                // that.state.report.interval may override the preconfigured report's default behavior,
                // so set it to selectedReport.interval. Needed in two places below
                that.state.report.interval = that.selectedReport.interval;
            } else {
                myQuery.groups = that.state.report.groups;
                myQuery.start = that.state.report.start;
                myQuery.end = that.state.report.end;
                myQuery.interval = that.state.report.interval;
                myQuery.resolution = +that.state.report.resolution;
            }

            const query = {
                start: moment(myQuery.start).format('YYYY-MM-DD'),
                end: moment(myQuery.end).format('YYYY-MM-DD'),
                groups: createQueryGroups(myQuery.groups),
                resolution: myQuery.resolution
            };

            workoutDataService.getWorkoutData(myQuery.interval, query)
            .then(function(res) {
                showReport(that.selectedReport, res);
            })
            .catch(function(e) {
                that.showReport = false;

                if (e.length === 0) {
                    // search succeeded, but no data
                    errorService.addError('REPORT_ERROR_EMPTY', e);
                } else {
                    // something else happened (server error, maybe)
                    errorService.addError('REPORT_ERROR', e);
                }
            })
            .finally(function() {
                that.loading = false;
            });
        } else if (that.selectedReport.name === 'ACCUMULATED_TIME_DISTANCE_ERRORS') {

            that.loading = true;
            that.loadingEta = null;
            that.loadingPercent = 0;

            let start = that.simpleTimeFrame2.name === 'SPECIFIC_MONTH' ?
                that.monthSelection.start : that.simpleTimeFrame2.start,
                end = that.simpleTimeFrame2.name === 'SPECIFIC_MONTH' ?
                that.monthSelection.end : that.simpleTimeFrame2.end;

            const machines = _.filter(viewableMachines(), that.getFilterPredicate()),
                { promise, abort } = usageReport.generate(machines, start, end, (eta, progress) => {
                    if (that.loading && machines.length > 20) {
                        that.loading = false;
                        that.loadingProgress = true;
                    } else {
                        that.loadingEta = eta;
                        that.loadingPercent = progress;
                    }
                });

            that.abort = abort;

            promise
            .then(res => {
                that.loading = false;
                that.loadingProgress = false;
                that.abort = null;

                showReport(that.selectedReport, res);
            })
            .catch(e => {
                that.loading = false;
                that.loadingProgress = false;
                that.abort = null;

                if (e.message !== 'abort') {
                    that.showReport = false;

                    errorService.addError('REPORT_ERROR', e);
                }
            });
        }

    };

    let timeInterval;
    function showReport(generatedReport, generatedReportData) {

        that.generatedReport = generatedReport;

        // Some reports have a data property that actually contains the data
        that.report = generatedReportData.data ? generatedReportData.data : generatedReportData;
        that.reportSubtype = that.state.report.subtype;
        that.reportInterval = that.state.report.interval;

        if (generatedReportData.timezone) {
            that.timezone = generatedReportData.timezone;
        }

        that.showReport = true;

        var date = moment();
        that.dateAbsolute = date.format('lll');

        // probably better to use angular-moment...
        if (angular.isDefined(timeInterval)) {
            $interval.cancel(timeInterval);
        }
        timeInterval = $interval(getRelativeTime, 1000 * 10);
        getRelativeTime();
        function getRelativeTime() {
            that.date = date.fromNow();
        }

        that.download = function() {
            var jsonData,
                csvData,
                barChartReports = [
                    'ACTIVE_AND_INACTIVE_EQUIPMENT',
                    'HEALTHY_AND_UNHEALTHY_EQUIPMENT',
                    'ERROR_ALERT_OFFLINE_EQUIPMENT'
                ],
                workoutReports = [
                    'TOTAL_HOURLY_USAGE_PERCENT_BY_EQUIPMENT_TYPE',
                    'TOTAL_HOURLY_USAGE_PERCENT_BY_MODEL',
                    'AVERAGE_USAGE_PERCENT'
                ];

            if (barChartReports.indexOf(generatedReport.name) !== -1) {
                jsonData = syncReport.convertToPapaTabular(that.report);
            } else if (workoutReports.indexOf(generatedReport.name) !== -1) {
                jsonData = workoutDataService.convertWorkoutDataToPapaTabular(that.report);
            } else if (generatedReport.name === 'ACCUMULATED_TIME_DISTANCE_ERRORS') {
                jsonData = usageReport.convertDataToPapaTabular(that.report);
            }

            csvData = Papa.unparse(jsonData);
            downloadService('am4-report-' + date.format() + '.csv', csvData);
        };
    }

    that.print = function() {
        window.print();
    };

    that.accumulatedReportSort = {
        accumulatedMilesOrSteps(usage) {
            if (usage.accumulated_miles_100_delta != null) {
                return usage.accumulated_miles_100_delta + 100000000000; // Always show KM/miles first
            }

            return usage.accumulated_steps_delta || 0;
        }
    };

    $scope.$watch(function() {return that.state;}, function(newVal) {
        appCacheService.setAppCache('appState', newVal);
        that.invalidColumns = determineInvalidColumns(that.state.currentElasticOptions, that.selectedReport.restrictedCols);
    }, true);

    $scope.$watch(function() {return that.selectedReport;}, function(newVal) {
        if (newVal) {
            that.invalidColumns = determineInvalidColumns(that.state.currentElasticOptions, newVal.restrictedCols);
        } else {
            that.invalidColumns = [];
        }
    }, true);

    function determineInvalidColumns(optionsObj, columns) {
        var invalidCols = [];
        if (columns) {
            columns.forEach(function(col) {
                if (optionsObj[col].length) {
                    invalidCols.push(col);
                }
            });
        }
        return invalidCols;
    }
});



// WEBPACK FOOTER //
// ./src/app/controllers/reportCtrl.js